/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionRecordListInner
 */
export interface GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];


